<template>
  <transition name="fade">
    <div
      class="absolute inset-0 flex items-end w-full h-full overflow-hidden bg-black bg-opacity-75"
      v-show="shown"
      @click.self="$emit('hide')"
    >
      <transition name="lift">
        <div
          class="w-full max-w-md pt-4 pb-8 mx-auto bg-gray-200 rounded-tl rounded-tr shadow-lg dark:bg-gray-800"
          v-show="shown"
        >
          <slot />
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ModalWrapper",
  props: ["shown"],
};
</script>
